// src/components/auth/AccountDialog.js
import React from 'react';
import {
  Dialog,
  DialogContent,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography,
  Avatar,
  IconButton,
  useTheme,
  Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import StarIcon from '@mui/icons-material/Star';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuth } from '../context/AuthContext';

export default function AccountDialog({ open, onClose }) {
  const theme = useTheme();
  const { currentUser, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      onClose();
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  const handleUpgradePlan = () => {
    console.log('Upgrade plan clicked');
    onClose();
  };

  if (!currentUser) {
    return null;
  }

  const letter = currentUser.email
    ? currentUser.email[0].toUpperCase()
    : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, overflow: 'hidden' }
      }}
    >
      <Paper elevation={0} sx={{ position: 'relative' }}>
        <Box
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            py: 3,
            textAlign: 'center'
          }}
        >
          <Avatar
            sx={{
              width: 70,
              height: 70,
              mx: 'auto',
              mb: 2,
              bgcolor: 'white',
              color: 'primary.main',
              border: '3px solid white',
              fontSize: '2rem'
            }}
          >
            {letter || <AccountCircleIcon fontSize="large" />}
          </Avatar>
          <Typography variant="h6" fontWeight="bold">
            {currentUser.email || 'User Account'}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
            Free Plan
          </Typography>
        </Box>

        <IconButton
          sx={{ position: 'absolute', top: 8, right: 8, color: 'white' }}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Paper>

      <DialogContent sx={{ pt: 2, pb: 2 }}>
        <List sx={{ py: 0 }}>
          <ListItemButton onClick={handleUpgradePlan} sx={{ borderRadius: 2 }}>
            <ListItemIcon>
              <StarIcon sx={{ color: theme.palette.warning.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Upgrade to Premium"
              secondary="Get unlimited access and features"
            />
          </ListItemButton>

          <Divider sx={{ my: 1.5 }} />

          <ListItemButton sx={{ borderRadius: 2 }}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText
              primary="Account Settings"
              secondary="Manage your profile"
            />
          </ListItemButton>

          <ListItemButton onClick={handleSignOut} sx={{ borderRadius: 2 }}>
            <ListItemIcon>
              <LogoutIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Sign Out"
              secondary="Log out of your account"
            />
          </ListItemButton>
        </List>
      </DialogContent>
    </Dialog>
  );
}